(function () {
  "use strict";
  var AT = function (s) { return window.AlgeaT ? window.AlgeaT(s) : s; };

  var ANALYSIS_WIDTH = 128;
  var TARGET_WIDTH = 0.84;
  var SAFE_BOUND = 0.92;
  var MIN_SCALE = 0.84;
  var MAX_SCALE = 1.4;
  var cache = new Map();
  /* W28: fits are remembered per photo (any rendition width) for the session and across visits,
     so a photo that was measured once is placed instantly instead of jumping after load. */
  var STORE_KEY = "algea-frame-fit-v1";
  var STORE_MAX = 800;
  var fits = loadFits();

  function loadFits() {
    try {
      var raw = window.localStorage && window.localStorage.getItem(STORE_KEY);
      var parsed = raw ? JSON.parse(raw) : null;
      return parsed && typeof parsed === "object" ? parsed : {};
    } catch (error) {
      return {};
    }
  }

  var saveTimer = null;
  function saveFits() {
    if (saveTimer) return;
    saveTimer = window.setTimeout(function () {
      saveTimer = null;
      try {
        var keys = Object.keys(fits);
        if (keys.length > STORE_MAX) {
          keys.slice(0, keys.length - STORE_MAX).forEach(function (k) { delete fits[k]; });
        }
        window.localStorage.setItem(STORE_KEY, JSON.stringify(fits));
      } catch (error) {
        /* storage full or blocked: the in-memory copy still works for this page */
      }
    }, 400);
  }

  /* One key per photo: CDN path + version, without the rendition size parameters. */
  function photoKey(src) {
    try {
      var url = new URL(src, window.location.href);
      return url.pathname + "?v=" + (url.searchParams.get("v") || "");
    } catch (error) {
      return String(src);
    }
  }

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function median(values) {
    var sorted = values.slice().sort(function (a, b) {
      return a - b;
    });
    return sorted[Math.floor(sorted.length / 2)] || 0;
  }

  function metricsFromPixels(data, width, height, sourceWidth, sourceHeight) {
    var edge = [];
    var step = Math.max(1, Math.floor(Math.min(width, height) / 64));
    var x;
    var y;

    for (x = 0; x < width; x += step) {
      [0, height - 1].forEach(function (edgeY) {
        var i = (edgeY * width + x) * 4;
        edge.push([data[i], data[i + 1], data[i + 2], data[i + 3]]);
      });
    }
    for (y = 0; y < height; y += step) {
      [0, width - 1].forEach(function (edgeX) {
        var i = (y * width + edgeX) * 4;
        edge.push([data[i], data[i + 1], data[i + 2], data[i + 3]]);
      });
    }

    var background = [0, 1, 2, 3].map(function (channel) {
      return median(
        edge.map(function (pixel) {
          return pixel[channel];
        }),
      );
    });
    var minX = width;
    var minY = height;
    var maxX = -1;
    var maxY = -1;
    var foregroundCount = 0;

    for (y = 0; y < height; y += 1) {
      for (x = 0; x < width; x += 1) {
        var offset = (y * width + x) * 4;
        var alpha = data[offset + 3];
        var colourDistance = Math.hypot(
          data[offset] - background[0],
          data[offset + 1] - background[1],
          data[offset + 2] - background[2],
        );
        var isForeground =
          background[3] < 32
            ? alpha > 48
            : alpha > 32 && colourDistance > 28;

        if (!isForeground) continue;
        foregroundCount += 1;
        minX = Math.min(minX, x);
        minY = Math.min(minY, y);
        maxX = Math.max(maxX, x);
        maxY = Math.max(maxY, y);
      }
    }

    if (maxX < minX) {
      return {
        found: false,
        width: width,
        height: height,
        sourceWidth: sourceWidth,
        sourceHeight: sourceHeight,
        background: background,
        foregroundFraction: 0,
      };
    }

    var boxWidth = maxX - minX + 1;
    var boxHeight = maxY - minY + 1;
    return {
      found: true,
      width: width,
      height: height,
      sourceWidth: sourceWidth,
      sourceHeight: sourceHeight,
      background: background,
      foregroundFraction: foregroundCount / (width * height),
      occupancyWidth: boxWidth / width,
      occupancyHeight: boxHeight / height,
      centerX: (minX + maxX + 1) / 2 / width,
      centerY: (minY + maxY + 1) / 2 / height,
    };
  }

  function isPlaceholderMetrics(metrics) {
    if (!metrics || !metrics.found) return false;
    var background = metrics.background || [];
    var lightBackground =
      background[3] > 240 &&
      background[0] > 235 &&
      background[1] > 235 &&
      background[2] > 235;

    return (
      lightBackground &&
      metrics.occupancyWidth >= 0.5 &&
      metrics.occupancyWidth <= 0.72 &&
      metrics.occupancyHeight <= 0.14 &&
      metrics.centerY >= 0.4 &&
      metrics.centerY <= 0.6 &&
      metrics.foregroundFraction <= 0.05
    );
  }

  function fitFromMetrics(metrics) {
    if (!metrics || !metrics.found) {
      return { scale: 1, translateX: 0, translateY: 0 };
    }

    var imageRatio = metrics.width / metrics.height;
    var contentWidth = imageRatio >= 1 ? 1 : imageRatio;
    var contentHeight = imageRatio >= 1 ? 1 / imageRatio : 1;
    var contentX = (1 - contentWidth) / 2;
    var contentY = (1 - contentHeight) / 2;
    var stageWidth = metrics.occupancyWidth * contentWidth;
    var stageHeight = metrics.occupancyHeight * contentHeight;
    var stageCenterX = contentX + metrics.centerX * contentWidth;
    var stageCenterY = contentY + metrics.centerY * contentHeight;
    var scale = clamp(TARGET_WIDTH / stageWidth, MIN_SCALE, MAX_SCALE);

    scale = Math.min(scale, SAFE_BOUND / Math.max(stageWidth, stageHeight));
    return {
      scale: Math.round(scale * 1000) / 1000,
      translateX:
        Math.round(clamp(0.5 - stageCenterX, -0.12, 0.12) * 1000) / 10,
      translateY:
        Math.round(clamp(0.5 - stageCenterY, -0.12, 0.12) * 1000) / 10,
    };
  }

  window.ALGEA_FRAME_MEDIA = {
    metricsFromPixels: metricsFromPixels,
    isPlaceholderMetrics: isPlaceholderMetrics,
    fitFromMetrics: fitFromMetrics,
  };

  if (
    typeof document === "undefined" ||
    typeof document.querySelector !== "function" ||
    typeof document.querySelectorAll !== "function"
  ) {
    return;
  }

  function analysisUrl(src) {
    var url = new URL(src, window.location.href);
    url.searchParams.set("width", String(ANALYSIS_WIDTH));
    return url.toString();
  }

  function whenIdle(callback) {
    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(callback, { timeout: 750 });
    } else {
      window.setTimeout(callback, 32);
    }
  }

  function analyse(src, sourceWidth, sourceHeight) {
    var key = analysisUrl(src);
    if (cache.has(key)) return cache.get(key);

    var promise = new Promise(function (resolve, reject) {
      var sample = new window.Image();
      var timer = window.setTimeout(function () {
        reject(new Error("Frame media analysis timed out"));
      }, 8000);

      sample.crossOrigin = "anonymous";
      sample.decoding = "async";
      sample.onload = function () {
        window.clearTimeout(timer);
        whenIdle(function () {
          try {
            var canvas = document.createElement("canvas");
            canvas.width = sample.naturalWidth;
            canvas.height = sample.naturalHeight;
            var context = canvas.getContext("2d", { willReadFrequently: true });
            context.drawImage(sample, 0, 0);
            var pixels = context.getImageData(0, 0, canvas.width, canvas.height);
            resolve(
              metricsFromPixels(
                pixels.data,
                canvas.width,
                canvas.height,
                sourceWidth,
                sourceHeight,
              ),
            );
          } catch (error) {
            reject(error);
          }
        });
      };
      sample.onerror = function () {
        window.clearTimeout(timer);
        reject(new Error("Frame media analysis image failed to load"));
      };
      sample.src = key;
    });

    cache.set(key, promise);
    promise.catch(function () {
      if (cache.get(key) === promise) cache.delete(key);
    });
    return promise;
  }

  function frameContext(image) {
    var card = image.closest(
      ".card-gallery[data-algea-product-kind='frame']",
    );
    if (card) return card;
    if (
      document.querySelector("[data-rx-drawer]") &&
      image.closest("media-gallery")
    ) {
      return image.closest("media-gallery");
    }
    return null;
  }

  function addPlaceholderState(image, container) {
    if (!container) return;
    image.dataset.algeaFrameMedia = "placeholder";
    image.setAttribute("aria-hidden", "true");
    container.dataset.algeaMediaState = "placeholder";

    if (container.querySelector(".algea-frame-media__empty")) return;
    var message = document.createElement("span");
    message.className = "algea-frame-media__empty";
    message.setAttribute("role", "img");
    message.setAttribute("aria-label", AT("Foto e produktit është në përgatitje"));
    var mark = document.createElement("span");
    mark.className = "algea-frame-media__empty-mark";
    mark.setAttribute("aria-hidden", "true");
    mark.textContent = "ALGEA";
    var copy = document.createElement("span");
    copy.textContent = AT("Foto në përgatitje");
    message.appendChild(mark);
    message.appendChild(copy);
    container.appendChild(message);
  }

  function applyFit(image, container, fit) {
    if (!container) return;
    var emptyState = container.querySelector(".algea-frame-media__empty");
    if (emptyState) emptyState.remove();
    image.removeAttribute("aria-hidden");
    image.dataset.algeaFrameMedia = "normalized";
    image.style.setProperty("--algea-frame-scale", String(fit.scale));
    image.style.setProperty("--algea-frame-x", fit.translateX + "%");
    image.style.setProperty("--algea-frame-y", fit.translateY + "%");
    container.dataset.algeaMediaState = "normalized";
  }

  /* Apply a remembered fit synchronously. Returns true when the photo is done. */
  function applyKnown(image, src) {
    var known = fits[photoKey(src)];
    if (!known) return false;
    var container = image.closest(".product-media-container") || image.parentElement;
    image.dataset.algeaFrameSource = src;
    if (known === "p") {
      image.dataset.algeaFrameMedia = "placeholder";
      addPlaceholderState(image, container);
    } else {
      applyFit(image, container, { scale: known[0], translateX: known[1], translateY: known[2] });
    }
    return true;
  }

  // Keep auxiliary samples behind the displayed photo, and bound network/CPU work.
  var pendingAnalysis = [];
  var activeAnalysis = 0;
  var analysisTokens = new WeakMap();
  var waitingLoads = new WeakMap();

  function drainAnalysis() {
    while (activeAnalysis < 2 && pendingAnalysis.length) {
      var job = pendingAnalysis.shift();
      if (!job.current()) { job.resolve(null); continue; }
      activeAnalysis += 1;
      (function (task) {
        Promise.resolve().then(function () {
          if (!task.current()) return null;
          return analyse(task.src, task.width, task.height);
        }).then(task.resolve, task.reject).then(function () {
          activeAnalysis -= 1;
          drainAnalysis();
        });
      })(job);
    }
  }

  function scheduledAnalysis(image, src, width, height, token) {
    return new Promise(function (resolve, reject) {
      pendingAnalysis.push({
        src: src, width: width, height: height, resolve: resolve, reject: reject,
        current: function () {
          return image.isConnected && analysisTokens.get(image) === token &&
            (image.currentSrc || image.src) === src;
        }
      });
      drainAnalysis();
    });
  }

  function waitForDisplayedImage(image) {
    if (waitingLoads.has(image)) return;
    function cleanup() {
      image.removeEventListener("load", ready);
      image.removeEventListener("error", cleanup);
      waitingLoads.delete(image);
    }
    function ready() { cleanup(); queue(image); }
    waitingLoads.set(image, cleanup);
    image.addEventListener("load", ready, { once: true });
    image.addEventListener("error", cleanup, { once: true });
  }

  function normalize(image) {
    if (!frameContext(image)) return;
    if (image.dataset.algeaFrameMedia) return;

    var src = image.currentSrc || image.src;
    if (!src) return;
    if (applyKnown(image, src)) return;
    if (!image.complete || !image.naturalWidth) {
      waitForDisplayedImage(image);
      return;
    }
    var token = {};
    analysisTokens.set(image, token);
    image.dataset.algeaFrameMedia = "analysing";
    image.dataset.algeaFrameSource = src;
    var container = image.closest(".product-media-container") || image.parentElement;
    var sourceWidth =
      Number(image.getAttribute("width")) || image.naturalWidth || 0;
    var sourceHeight =
      Number(image.getAttribute("height")) || image.naturalHeight || 0;

    scheduledAnalysis(image, src, sourceWidth, sourceHeight, token)
      .then(function (metrics) {
        if (!image.isConnected || analysisTokens.get(image) !== token || image.dataset.algeaFrameSource !== src || (image.currentSrc || image.src) !== src) return;
        if (!metrics) return;
        if (isPlaceholderMetrics(metrics)) {
          fits[photoKey(src)] = "p";
          saveFits();
          addPlaceholderState(image, container);
          return;
        }
        var fit = fitFromMetrics(metrics);
        fits[photoKey(src)] = [fit.scale, fit.translateX, fit.translateY];
        saveFits();
        applyFit(image, container, fit);
      })
      .catch(function () {
        if (!image.isConnected || analysisTokens.get(image) !== token || image.dataset.algeaFrameSource !== src || (image.currentSrc || image.src) !== src) return;
        image.dataset.algeaFrameMedia = "fallback";
        if (container) container.dataset.algeaMediaState = "fallback";
        var retries = Number(image.dataset.algeaFrameRetries || 0);
        if (retries < 1) {
          image.dataset.algeaFrameRetries = String(retries + 1);
          window.setTimeout(function () {
            if (
              image.isConnected &&
              image.dataset.algeaFrameMedia === "fallback" &&
              image.dataset.algeaFrameSource === src
            ) {
              delete image.dataset.algeaFrameMedia;
              delete image.dataset.algeaFrameSource;
              queue(image);
            }
          }, 3000);
        }
      });
  }

  var intersection =
    "IntersectionObserver" in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              intersection.unobserve(entry.target);
              normalize(entry.target);
            });
          },
          { rootMargin: "200px 0px" },
        )
      : null;

  function queue(image) {
    if (image.dataset.algeaFrameMedia) return;
    var src = image.currentSrc || image.src;
    if (src && frameContext(image) && applyKnown(image, src)) return;
    if (intersection) intersection.observe(image);
    else normalize(image);
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope
      .querySelectorAll(
        ".card-gallery[data-algea-product-kind='frame'] img.product-media__image",
      )
      .forEach(queue);

    if (document.querySelector("[data-rx-drawer]")) {
      scope
        .querySelectorAll("media-gallery img.product-media__image")
        .forEach(queue);
    }
  }

  function clearImageState(image) {
    analysisTokens.delete(image);
    var cleanupLoad = waitingLoads.get(image);
    if (cleanupLoad) cleanupLoad();
    if (intersection) intersection.unobserve(image);
    var container =
      image.closest(".product-media-container") || image.parentElement;
    if (container) {
      var emptyState = container.querySelector(".algea-frame-media__empty");
      if (emptyState) emptyState.remove();
      delete container.dataset.algeaMediaState;
    }
    delete image.dataset.algeaFrameMedia;
    delete image.dataset.algeaFrameSource;
    delete image.dataset.algeaFrameRetries;
    image.removeAttribute("aria-hidden");
    image.style.removeProperty("--algea-frame-scale");
    image.style.removeProperty("--algea-frame-x");
    image.style.removeProperty("--algea-frame-y");
  }

  function resetImage(image) {
    if (!frameContext(image)) return;
    var src = image.currentSrc || image.src;
    /* A new rendition of the same photo (srcset width change) keeps its fit: no reset, no jump. */
    if (src && image.dataset.algeaFrameSource && photoKey(src) === photoKey(image.dataset.algeaFrameSource) &&
        (image.dataset.algeaFrameMedia === "normalized" || image.dataset.algeaFrameMedia === "placeholder")) {
      image.dataset.algeaFrameSource = src;
      return;
    }
    clearImageState(image);
    queue(image);
  }

  function releaseTree(node) {
    if (node.nodeType !== 1) return;
    if (node.matches && node.matches("img.product-media__image")) {
      clearImageState(node);
    }
    if (node.querySelectorAll) {
      node
        .querySelectorAll("img.product-media__image")
        .forEach(clearImageState);
    }
  }

  function start() {
    scan(document);
    if (!("MutationObserver" in window)) return;
    var mutations = new MutationObserver(function (records) {
      records.forEach(function (record) {
        if (record.type === "attributes") {
          if (
            record.target.matches &&
            record.target.matches("img.product-media__image")
          ) {
            resetImage(record.target);
          } else if (
            record.target.matches &&
            record.target.matches("source")
          ) {
            var picture = record.target.closest("picture");
            var pictureImage =
              picture && picture.querySelector("img.product-media__image");
            if (pictureImage) resetImage(pictureImage);
          }
          return;
        }
        record.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches("img.product-media__image")) queue(node);
          scan(node);
        });
        record.removedNodes.forEach(releaseTree);
      });
    });
    mutations.observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ["src", "srcset"],
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
  document.addEventListener("shopify:section:load", function (event) {
    scan(event.target);
  });
  document.addEventListener(
    "load",
    function (event) {
      var image = event.target;
      if (
        !image.matches ||
        !image.matches("img.product-media__image") ||
        !frameContext(image)
      ) {
        return;
      }
      var src = image.currentSrc || image.src;
      if (image.dataset.algeaFrameSource !== src) resetImage(image);
    },
    true,
  );
  document.addEventListener("variant:update", function () {
    scan(document);
  });
})();

